import SessionDetailsItem from "@app.automotus.io/components/SessionDetailsItem";
import TextField from "@mui/material/TextField";
import React from "react";
import * as Yup from "yup";
import { Field } from "formik";

export const VehicleMakeSessionDetailsItem: React.FC<VehicleMakeSessionDetailsItemProps> = ({
  loading,
  vehicleMake,
  skeletonWidth,
  onSubmitEdit,
}) => {
  const initialValues: VehicleMakeFormValues = {
    make: vehicleMake || "",
  };

  const validationSchema = Yup.object({
    make: Yup.string().required("Make is required"),
  });

  return (
    <SessionDetailsItem
      loading={loading}
      title={"Vehicle Make"}
      content={vehicleMake}
      skeletonWidth={skeletonWidth}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmitEdit={onSubmitEdit}
    >
      {({ errors, touched }) => (
        <Field
          as={TextField}
          name="make"
          autoFocus
          fullWidth
          error={touched.make && Boolean(errors.make)}
          helperText={touched.make && errors.make}
        />
      )}
    </SessionDetailsItem>
  );
};

export interface VehicleMakeFormValues {
  make: string;
}

export interface VehicleMakeSessionDetailsItemProps {
  loading?: boolean;
  vehicleMake?: string;
  skeletonWidth?: number;
  onSubmitEdit?: (values: VehicleMakeFormValues) => Promise<void>;
}

export default VehicleMakeSessionDetailsItem;
